import http from '../../../../libs/http'
export default (id, payload = { name: '', code: '', state: true }) => http.put(`${process.env.VUE_APP_MICROSERVICE_API_SHOPS}/order-state/${id}`, payload)
